import type { ViewBlockAbstract } from '@lighthouse/core'
import { useAtomData } from '@lighthouse/shared'
import { useMemo } from 'react'

import { selectedBlockContextAtom, selectedBlockCustomViewAtom } from '@/atoms/page/state'

export function useCurrentCustomViewBlock(): ViewBlockAbstract | undefined {
    const ancestor = useAtomData(selectedBlockCustomViewAtom)
    const selectedContext = useAtomData(selectedBlockContextAtom)
    const selectedBlock = selectedContext?.block

    return useMemo(() => {
        if (ancestor) {
            return ancestor
        }
        if (selectedBlock?.type === 'view' && selectedBlock.config.viewType === 'custom') {
            return selectedBlock
        }
    }, [ancestor, selectedBlock])
}
